import { createContext } from 'react';

export const initialState = {
  relatedList: [],
};
const ExternSearchContext = createContext(initialState);

export const { Provider } = ExternSearchContext;
export default ExternSearchContext;
